export default __webpack_public_path__ + "static/media/Onion Seeds.bfbe4983.PNG";